import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import ProductSelector from 'common/components/shop/ProductSelector';
import compact from 'lodash/fp/compact';
import isEmpty from 'lodash/fp/isEmpty';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';

export const buildSelectorTitle = (hasMultipleOptions, translationKey) => {
  const optionMessage = (
    <TranslatedMessage id={`cart.pod_filters.${translationKey}`} />
  );

  if (hasMultipleOptions)
    return (
      <TranslatedMessage
        id={'cart.pod_filters.choose_filter'}
        values={{
          filter: optionMessage,
        }}
      />
    );

  return optionMessage;
};

export const getNicotineStrengthSelectorData = nicotineStrengthOptions => {
  if (isEmpty(nicotineStrengthOptions)) return null;

  const options = nicotineStrengthOptions.map(nicotineStrength => ({
    title: nicotineStrength,
    value: nicotineStrength,
  }));

  return {
    name: 'nicotine-strength',
    options,
    title: buildSelectorTitle(options.length > 1, 'nicotine_strength'),
    type: 'nicotineStrength',
    formatValue: value => `${value}`,
  };
};

export const getPodCountSelectorData = podCountOptions => {
  if (isEmpty(podCountOptions)) return null;

  const options = podCountOptions.map(({ podCount, price }) => ({
    subText: <PriceSpan amount={price} />,
    title: (
      <TranslatedMessage
        id={'cart.pod_filters.juulpod_count'}
        values={{ podCount }}
      />
    ),
    value: `${podCount}`,
  }));

  return {
    name: 'pod-count',
    options,
    title: buildSelectorTitle(options.length > 1, 'pack_size'),
    type: 'podCount',
    formatValue: parseFloat,
  };
};

const PodFilters = ({
  podCountOptions,
  nicotineStrengthOptions,
  onChangeFilter,
}) => {
  const podCountSelectorData = getPodCountSelectorData(podCountOptions);
  const nicotineStrengthSelectorData = getNicotineStrengthSelectorData(
    nicotineStrengthOptions
  );

  return (
    <div className={classNames('pod-filters', 'content-wrapper')}>
      {flow(
        compact,
        map(({ type, name, options, title, formatValue }) => (
          <div key={`pod-filter-item-${name}`} className="pod-filters__item">
            <ProductSelector
              {...{ name, options, title }}
              onChange={value => onChangeFilter({ [type]: formatValue(value) })}
            />
          </div>
        ))
      )([podCountSelectorData, nicotineStrengthSelectorData])}
    </div>
  );
};

PodFilters.propTypes = {
  nicotineStrengthOptions: PropTypes.arrayOf(PropTypes.string),
  podCountOptions: PropTypes.arrayOf(
    PropTypes.shape({
      podCount: PropTypes.number,
      price: PropTypes.number,
    })
  ),
  onChangeFilter: PropTypes.func,
};

export default PodFilters;
